"use client";

import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Typography,
  Select,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Paper,
  InputLabel,
  FormControl,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
// import { formatTimeDate } from "@/common/commonFuction";
import { Link } from "react-router-dom";
import CreateSubcategory from "./CreateSubCategory";

const SubcategoryList = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [businessTypes, setBusinessTypes] = useState([]);
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedBusinessType, setSelectedBusinessType] = useState(null);

  // Edit form fields
  const [editCategoryName, setEditCategoryName] = useState("");
  const [editsubcategoryName, setEditSubcategoryName] = useState("");
  const [editSubcategoryType, setEditSubcategoryType] = useState("");
  const [editStatus, setEditStatus] = useState(true);
  const [editId, setEditId] = useState("");
  const [open, setOpen] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  useEffect(() => {
    fetch(
      `${process.env.REACT_APP_API_URL}/api/admin/subcategory/getall-subcategory`,
    )
      .then((res) => res.json())
      .then((data) => setBusinessTypes(data))
      .catch((err) => console.error("Error fetching subcategories:", err));
  }, []);

  const handleSave = async (data) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/admin/subcategory/save-subcategory`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            businessType: data.businessType,
            category: data.category,
            subcategory_name: data.subcategoryName,
            subcategory_type: data.subcategoryType,
            description: data.description,
            status: true,
          }),
        },
      );

      if (response.ok) {
        // Refresh the list
        const res = await fetch(
          `${process.env.REACT_APP_API_URL}/api/admin/subcategory/getall-subcategory`,
        );
        const refreshedData = await res.json();
        setBusinessTypes(refreshedData);
      }
    } catch (error) {
      console.error("Error saving subcategory:", error);
    }
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value.toLowerCase());
    setCurrentPage(1);
  };

  const handleEditClick = (product) => {
    setSelectedBusinessType(product.businessType);
    setEditCategoryName(product.category);
    setEditSubcategoryName(product.subcategory_name);
    setEditSubcategoryType(product.subcategory_type);
    setEditStatus(product.status);
    setEditId(product._id);
    setShowEditModal(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this item?")) {
      try {
        await fetch(
          `${process.env.REACT_APP_API_URL}/api/admin/subcategory/save-subcategory`,
          {
            method: "DELETE",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ _id: id }),
          },
        );
        const res = await fetch(
          `${process.env.REACT_APP_API_URL}/api/admin/subcategory/getall-subcategory`,
        );
        const data = await res.json();
        setBusinessTypes(data);
      } catch (error) {
        console.error("Error deleting subcategory:", error);
      }
    }
  };

  const handleSaveChanges = async () => {
    try {
      await fetch(
        `${process.env.REACT_APP_API_URL}/api/admin/subcategory/save-subcategory`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            businessType: selectedBusinessType,
            category: editCategoryName,
            subcategory_name: editsubcategoryName,
            subcategory_type: editSubcategoryType,
            status: editStatus,
            _id: editId,
          }),
        },
      );
      setShowEditModal(false);
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/api/admin/subcategory/getall-subcategory`,
      );
      const data = await res.json();
      setBusinessTypes(data);
    } catch (error) {
      console.error("Error updating subcategory:", error);
    }
  };

  // Filter and paginate
  const filtered = businessTypes.filter((item) =>
    item.subcategory_name?.toLowerCase().includes(searchQuery),
  );

  const totalPages = Math.ceil(filtered.length / itemsPerPage);
  const currentData = filtered.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage,
  );

  return (
    <Paper sx={{ padding: 3 }}>
      <Box
        display="flex"
        justifyContent="space-between"
        flexWrap="wrap"
        gap={2}
        mb={2}
      >
        <TextField
          size="small"
          variant="outlined"
          placeholder="Search Subcategory"
          value={searchQuery}
          onChange={handleSearchChange}
          InputProps={{
            startAdornment: <SearchIcon sx={{ mr: 1 }} />,
          }}
        />
        <Button variant="outlined" onClick={() => setOpen(true)}>
          Add New Sub Category
        </Button>
        <CreateSubcategory
          open={open}
          onClose={() => setOpen(false)}
          onSave={handleSave}
        />
      </Box>

      <TableContainer component={Paper} sx={{ boxShadow: "none" }}>
        <Table sx={{ minWidth: 1300 }} aria-label="business table">
          <TableHead className="bg-primary-50">
            <TableRow
              sx={{
                th: {
                  fontWeight: "500",
                  padding: "10px 24px",
                  fontSize: "14px",
                },
              }}
            >
              <TableCell sx={{}} className="text-black border-bottom">
                ID
              </TableCell>
              <TableCell className="text-black border-bottom">
                Business Type
              </TableCell>
              <TableCell className="text-black border-bottom">
                Category
              </TableCell>
              <TableCell className="text-black border-bottom">
                Sub Category
              </TableCell>
              <TableCell className="text-black border-bottom">Type</TableCell>
              <TableCell className="text-black border-bottom">
                Created At
              </TableCell>
              <TableCell className="text-black border-bottom">Status</TableCell>
              <TableCell className="text-black border-bottom">Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {currentData.length > 0 ? (
              currentData.map((product, index) => (
                <TableRow key={index}>
                  <TableCell>#{product._id?.slice(-4)}</TableCell>
                  <TableCell>{product.businessType}</TableCell>
                  <TableCell>{product.category}</TableCell>
                  <TableCell>{product.subcategory_name}</TableCell>
                  <TableCell>{product.subcategory_type}</TableCell>
                  {/* <TableCell>{formatTimeDate(product.createdAt)}</TableCell> */}
                  <TableCell>
                    <Typography color={product.status ? "green" : "red"}>
                      {product.status ? "Active" : "Inactive"}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <IconButton onClick={() => handleEditClick(product)}>
                      <EditIcon fontSize="small" />
                    </IconButton>
                    <IconButton
                      onClick={() => handleDelete(product._id)}
                      color="error"
                    >
                      <DeleteIcon fontSize="small" />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={8} align="center">
                  No data found.
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Pagination */}
      {totalPages > 1 && (
        <Box display="flex" justifyContent="center" mt={2} gap={1}>
          <Button
            size="small"
            disabled={currentPage === 1}
            onClick={() => setCurrentPage((prev) => prev - 1)}
          >
            Prev
          </Button>
          {[...Array(totalPages)].map((_, idx) => (
            <Button
              key={idx}
              size="small"
              variant={currentPage === idx + 1 ? "contained" : "outlined"}
              onClick={() => setCurrentPage(idx + 1)}
            >
              {idx + 1}
            </Button>
          ))}
          <Button
            size="small"
            disabled={currentPage === totalPages}
            onClick={() => setCurrentPage((prev) => prev + 1)}
          >
            Next
          </Button>
        </Box>
      )}

      {/* Edit Modal */}
      <Dialog
        open={showEditModal}
        onClose={() => setShowEditModal(false)}
        fullWidth
      >
        <DialogTitle>Edit Sub Category</DialogTitle>
        <DialogContent>
          <TextField
            margin="dense"
            label="Business Type"
            fullWidth
            value={selectedBusinessType}
            onChange={(e) => setSelectedBusinessType(e.target.value)}
          />
          <TextField
            margin="dense"
            label="Category"
            fullWidth
            value={editCategoryName}
            onChange={(e) => setEditCategoryName(e.target.value)}
          />
          <TextField
            margin="dense"
            label="Sub Category"
            fullWidth
            value={editsubcategoryName}
            onChange={(e) => setEditSubcategoryName(e.target.value)}
          />
          <TextField
            margin="dense"
            label="Sub Category Type"
            fullWidth
            value={editSubcategoryType}
            onChange={(e) => setEditSubcategoryType(e.target.value)}
          />
          <FormControl fullWidth margin="dense">
            <InputLabel>Status</InputLabel>
            <Select
              value={editStatus ? "active" : "inactive"}
              onChange={(e) => setEditStatus(e.target.value === "active")}
              label="Status"
            >
              <MenuItem value="active">Active</MenuItem>
              <MenuItem value="inactive">Inactive</MenuItem>
            </Select>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setShowEditModal(false)}>Cancel</Button>
          <Button variant="contained" onClick={handleSaveChanges}>
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </Paper>
  );
};

export default SubcategoryList;
